import React from 'react'
import Chip from '@mui/material/Chip'

const toneMap = {
  success: { color: 'success', variant: 'outlined' },
  warning: { color: 'warning', variant: 'outlined' },
  error: { color: 'error', variant: 'outlined' },
  info: { color: 'info', variant: 'outlined' },
  default: { color: 'default', variant: 'outlined' },
}

/**
 * @param {{ label: string, tone?: keyof typeof toneMap, size?: 'small' | 'medium' }} props
 */
export default function StatusBadge({ label, tone = 'default', size = 'small' }) {
  const cfg = toneMap[tone] || toneMap.default
  return (
    <Chip
      label={label}
      size={size}
      color={cfg.color}
      variant={cfg.variant}
      sx={(theme) => ({
        fontWeight: 900,
        letterSpacing: 0.35,
        bgcolor:
          tone === 'default'
            ? theme.palette.mode === 'dark' ? 'rgba(240,198,106,0.07)' : 'rgba(91,63,214,0.05)'
            : undefined,
        boxShadow:
          theme.palette.mode === 'dark'
            ? 'inset 0 1px 0 rgba(255,255,255,0.06)'
            : 'inset 0 1px 0 rgba(255,255,255,0.72)',
      })}
    />
  )
}
